// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".margin-top-20[data-v-0a4e4662]{margin-top:20px}.icon[data-v-0a4e4662]{color:#3e4cd4;height:60px;left:calc(50% - 25px);margin-bottom:40px;right:50%;top:50px;width:60px}.congrats-message[data-v-0a4e4662]{padding:10px 5%;text-align:center}@media print,screen and (min-width:769px){.congrats-message[data-v-0a4e4662]{padding:10px}}.feature-box[data-v-0a4e4662]{border:1px solid #000;border-radius:5px;margin:10px 0;padding:20px 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
